import React from 'react'
import PublicLayout from '@/pages/PublicLayout'
import Simple from '@/components/layouts/AuthLayout/Simple'
import Alert from '@/components/ui/Alert'
import { ResetPasswordBase } from '@/components/pages/auth/ResetPassword'
import { Head, usePage } from '@inertiajs/react'

type ResetPasswordPageProps = {
    token?: string | null
    email?: string | null
}

const ResetPasswordPage = () => {
    const { token, email } = usePage<ResetPasswordPageProps>().props

    return (
        <>
            <Head>
                <title>Reset Password</title>
                <meta
                    name="description"
                    content="Set a new password for your MemoSlate account."
                />
            </Head>
            <Simple>
                {token && email ? (
                    <ResetPasswordBase token={token} email={email} />
                ) : (
                    <div>
                        <h3 className="mb-2">Invalid reset link</h3>
                        <Alert showIcon type="danger">
                            Invalid or expired reset link.
                        </Alert>
                    </div>
                )}
            </Simple>
        </>
    )
}

ResetPasswordPage.layout = (page: React.ReactNode) => (
    <PublicLayout children={page} />
)

export default ResetPasswordPage
